import React from "react";
import { Link } from "react-router-dom";

const Policies = () => {
  const policies = [
    { id: 1, title: "Sistema de Gestión Integrado", file: "/Docs/POLÍTICA DEL SISTEMA DE GESTIÓN INTEGRADO.pdf" },
    { id: 2, title: "Prevención del Consumo de Sustancias Psicoactivas, Tabaco y Alcohol", file: "/Docs/POLÍTICA DE PREVENCIÓN DEL CONSUMO DE SUSTANCIAS PSICOACTIVAS, TABACO Y ALCOHOL.pdf" },
    { id: 3, title: "Prevención del Acoso Laboral", file: "/Docs/POLÍTICA DE PREVENCIÓN DEL ACOSO LABORAL.pdf" },
    { id: 4, title: "Desconexión Laboral", file: "/Docs/POLÍTICA DE DESCONEXION LABORAL.pdf" },
    { id: 5, title: "Diversidad, Equidad e Inclusión", file: "/Docs/POLÍTICA DE DIVERSIDAD, EQUIDAD E INCLUSIÓN.pdf" },
    { id: 6, title: "Estilos de Vida Saludables", file: "/Docs/POLÍTICA DE ESTILOS DE VIDA SALUDABLES.pdf" },
    { id: 7, title: "Condiciones Laborales", file: "/Docs/POLITICA DE CONDICIONES LABORALES.pdf" },
    { id: 8, title: "Derechos Humanos", file: "/Docs/POLÍTICA EN DERECHOS HUMANOS.pdf" },
    { id: 9, title: "Seguridad de la Información y Tecnología (PSIT)", file: "/Docs/POLÍTICA DE SEGURIDAD DE LA INFORMACIÓN Y TECNOLOGÍA (PSIT).pdf" },
    { id: 10, title: "Sostenibilidad", file: "/Docs/POLITICA DE SOSTENIBILIDAD.pdf" },
  ];

  const generateFilename = (title) =>
    title
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s]/gi, "")
      .replace(/\s+/g, "_")
      .toLowerCase() + ".pdf";

  return (
    <div className="w-full max-w-[900px] mx-auto px-5 py-20 font-sans bg-white">

      {/* TITLE */}
      <h1 className="text-center uppercase font-extrabold text-gray-900 tracking-wide mb-12 text-[clamp(24px,5vw,34px)]">
        Políticas Corporativas
      </h1>

      {/* LIST */}
      <div className="border-t border-gray-200">
        {policies.map((policy) => {
          const filename = generateFilename(policy.title);

          return (
            <div key={policy.id} className="border-b border-gray-200">
              <a
                href={policy.file}
                download={filename}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  flex items-center justify-between
                  px-4 py-4
                  uppercase
                  font-semibold
                  text-[15px]
                  text-gray-800
                  transition-all duration-200
                  hover:bg-gray-50
                "
              >
                {/* TEXTO */}
                <span className="
                  transition-colors duration-200
                  group-hover:text-orange-500
                ">
                  {policy.title}
                </span>

                {/* FLECHA */}
                <span className="
                  ml-4
                  text-gray-500
                  text-lg
                  transition-colors duration-200
                  group-hover:text-orange-500
                ">
                  ↓
                </span>
              </a>
            </div>
          );
        })}
      </div>

      {/* CONTACTO */}
      <div className="mt-10 pt-5 text-right max-md:text-center">
        <Link
          to="/contact-us"
          className="
            text-sm text-gray-500
            border-b border-transparent
            transition-all
            hover:text-orange-500
            hover:border-orange-500
          "
        >
          ¿Necesitas más información?
        </Link>
      </div>
    </div>
  );
};

export default Policies;